import { forwardRef, PropsWithChildren } from 'react';

interface ReportLayoutProps {
  title: string;
  subtitle?: string;
  footerNote?: string;
}

/**
 * Basic print-friendly layout for PDF exports.
 * Provides header/footer wrappers and constrained width.
 */
export const ReportLayout = forwardRef<HTMLDivElement, PropsWithChildren<ReportLayoutProps>>(
  ({ title, subtitle, footerNote, children }, ref) => (
    <div
      ref={ref}
      style={{
        width: '210mm', // A4 width
        minHeight: '297mm',
        margin: '0 auto',
        padding: '24px',
        backgroundColor: '#ffffff',
        color: '#0f172a',
        fontFamily: 'Inter, Arial, sans-serif',
        boxSizing: 'border-box',
      }}
    >
      <header style={{ borderBottom: '1px solid #e5e7eb', paddingBottom: 12, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: 10, color: '#6b7280', margin: 0 }}>PivotKit Report</p>
            <h1 style={{ fontSize: 22, fontWeight: 700, margin: '2px 0' }}>{title}</h1>
            {subtitle && <p style={{ fontSize: 12, color: '#4b5563', margin: 0 }}>{subtitle}</p>}
          </div>
          <div style={{ textAlign: 'right' }}>
            <p style={{ margin: 0, fontSize: 10, color: '#6b7280' }}>
              Generated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer style={{ borderTop: '1px solid #e5e7eb', marginTop: 16, paddingTop: 8 }}>
        <p style={{ fontSize: 10, color: '#6b7280', margin: 0 }}>
          {footerNote || 'Internal use only · Generated by PivotKit'}
        </p>
      </footer>
    </div>
  )
);
ReportLayout.displayName = 'ReportLayout';
